import {
  Flame,         // 🔥 -> oven, grill  
  ChefHat,       // 🍳 -> stovetop, cooking
  Zap,           // ⚡ -> instant pot, toaster oven, microwave alternative
  Wind,          // 💨 -> air fryer
  Clock,         // ⏰ -> slow cooker, time
  Radio,         // 📡 -> microwave (radio waves)
  Soup,          // 🍚 -> rice cooker (bowl/soup alternative)
  Blend,         // 🌪️ -> blender (mixing/blending)
  Settings,      // ⚙️ -> food processor
  Wand2,         // 🪄 -> immersion blender (magic wand alternative)
  Milk,          // 🥛 -> stand mixer (milk/liquid mixing)
  Factory,       // 🏭 -> full batch prep
  Users,         // 👨‍👩‍👧‍👦 -> family/household
  Rocket,        // 🚀 -> speed/efficiency
  Thermometer,   // 🌶️ -> spice level indicator
  Target,        // 🎯 -> goals/targets
  Scale,         // ⚖️ -> balance/weight
  AlertTriangle, // ⚠️ -> warning
  Utensils,      // 🍽️ -> dining/eating
} from 'lucide-react';

// Equipment icon mappings
export const equipmentIcons = {
  'oven': Flame,
  'stovetop': ChefHat,
  'microwave': Radio,
  'air-fryer': Wind,
  'slow-cooker': Clock,
  'instant-pot': Zap,
  'rice-cooker': Soup,
  'blender': Blend,
  'food-processor': Settings,
  'grill': Flame,
  'stand-mixer': Milk,
  'immersion-blender': Wand2,
  'toaster-oven': Zap,
} as const;

// Batch prep icon mappings
export const batchPrepIcons = {
  'none': ChefHat,        // 🍳 -> cook fresh
  'light': Zap,           // ⚡ -> quick/light prep
  'full': Factory,        // 🏭 -> full batch prep
} as const;

// Goal icon mappings
export const goalIcons = {
  'lose-weight': Flame,   // 🔥 -> burning calories
  'maintain': Scale,      // ⚖️ -> balance
  'gain-muscle': Target,  // Target for goals
} as const;

// Spice level mappings
export const spiceLevelText = {
  1: "Mild heat",
  2: "Medium spice", 
  3: "Spicy!",
  4: "Extra hot!",
  5: "Bring the fire!"
} as const;

// Utility function to get equipment icon
export const getEquipmentIcon = (equipmentId: string) => {
  return equipmentIcons[equipmentId as keyof typeof equipmentIcons] || Settings;
};

// Utility function to get batch prep icon
export const getBatchPrepIcon = (prepType: string) => {
  return batchPrepIcons[prepType as keyof typeof batchPrepIcons] || ChefHat;
};

// Utility function to get goal icon
export const getGoalIcon = (goalType: string) => {
  return goalIcons[goalType as keyof typeof goalIcons] || Target;
};